// Calls for the invitation-code sign-up (backend: routes/signup_routes.py).
// verify/set-password are public (the person has no password yet);
// completeSignup runs signed in, right after the first MFA sign-in.
import axios from 'axios';
import { baseApi } from '../../API/api';
import { authHeaders } from '../../utils/authHeader';
import { CONSENT_VERSION } from '../Sms/smsConsent';

/** The backend's message for a failed call, or a generic one. */
export function errorMessage(error) {
  return error?.response?.data?.error || 'Something went wrong. Please try again.';
}

/** Resolves to the code's purpose: 'invite' (create an account) or 'reset' (an admin's password reset code). */
export async function verifyInvitation(email, code) {
  const response = await axios.post(`${baseApi}/api/signup/verify-invitation`, { email, code });
  return response?.data?.purpose === 'reset' ? 'reset' : 'invite';
}

export async function setSignupPassword(email, code, password) {
  await axios.post(`${baseApi}/api/signup/set-password`, { email, code, password });
}

/** Text-message sign-in: the ticked consent box and the number (E.164). */
export async function setSignupPhone(email, code, phone) {
  await axios.post(`${baseApi}/api/signup/set-phone`, { email, code, phone, consent_version: CONSENT_VERSION });
}

export async function completeSignup() {
  await axios.post(`${baseApi}/api/signup/complete`, {}, { headers: await authHeaders() });
}
